import {LocalStorage} from "./LocalStorage";

const API_TOKEN = "token.api";
const USER_HASH = "hash.api";
const PRIMARY_LANGUAGE = "language.primary";
const SAAS = "saas";

export class AppStorage extends LocalStorage {

    storeToken(value) {
        this.set(API_TOKEN, value);
    };

    storeUserHash(value) {
        this.set(USER_HASH, value);
    };

    storePrimaryLanguage(locale) {
        this.set(PRIMARY_LANGUAGE, locale);
    }

    storeSaas(saas) {
        this.set(SAAS, saas);
    }

    storeAPICredentials(token, userHash) {
        this.storeToken(token);
        this.storeUserHash(userHash);
    };

    getToken() {
        return this.get(API_TOKEN, null);
    };

    getUserHash() {
        return this.get(USER_HASH, null);
    };

    getPrimaryLanguage() {
        return this.get(PRIMARY_LANGUAGE, null);
    };

    isSaas() {
        return "true" === this.get(SAAS, false);
    };

    validToken() {
        return "" !== this.getToken() && null !== this.getToken();
    };


    validUserHash() {
        return "" !== this.getUserHash() && null !== this.getUserHash();
    };


    isValid() {
        return this.validToken() && this.validUserHash();
    };

    deleteToken() {
        this.storeToken(null);
    };

    deleteUserHash() {
        this.storeUserHash(null);
    };

    clearAPICredentials() {
        this.deleteToken();
        this.deleteUserHash();
    }

}
